export default "__VITE_ASSET__ASWuETYF__"